/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2022-11-25 10:38:52
 * @LastEditors: changfeng
 * @LastEditTime: 2022-12-13 17:24:10
 */
import React, { PureComponent } from 'react';

const groupActionsPositionList = {
  topLeft: 'group--actions--tl',
  topCenter: 'group--actions--tc',
  topRight: 'group--actions--tr',
  bottomLeft: 'group--actions--bl',
  bottomCenter: 'group--actions--bc',
  bottomRight: 'group--actions--br',
};

/**修改 action的默认定位 */
// const defaultPosition = "topRight";
const defaultPosition = 'bottomLeft';

export class GroupActions extends PureComponent {
  render() {
    const {
      config,
      addRule,
      addGroup,
      removeSelf,
      setLock,
      isLocked,
      isTrueLocked,
      id,
      canAddGroup,
      canAddRule,
      canDeleteGroup,
    } = this.props;
    const {
      immutableGroupsMode,
      addRuleLabel,
      addGroupLabel,
      delGroupLabel,
      groupActionsPosition,
      renderButton: Btn,
      renderSwitch: Switch,
      renderButtonGroup: BtnGrp,
      lockLabel,
      lockedLabel,
      showLock,
      canDeleteLocked,
    } = config.settings;
    const position =
      groupActionsPositionList[groupActionsPosition || defaultPosition];

    const setLockSwitch = showLock && !(isLocked && !isTrueLocked) && (
      <Switch
        type="lock"
        id={id}
        value={isLocked}
        setValue={setLock}
        label={lockLabel}
        checkedLabel={lockedLabel}
        config={config}
      />
    );

    const addRuleBtn = !immutableGroupsMode && canAddRule && !isLocked && (
      <Btn
        type="addRule"
        onClick={addRule}
        label={addRuleLabel}
        readonly={isLocked}
        config={config}
      />
    );
    const addGroupBtn = !immutableGroupsMode && canAddGroup && !isLocked && (
      <Btn
        type="addGroup"
        onClick={addGroup}
        label={addGroupLabel}
        readonly={isLocked}
        config={config}
      />
    );
    const delGroupBtn = !immutableGroupsMode &&
      canDeleteGroup &&
      (!isLocked || (isLocked && canDeleteLocked)) && (
        <Btn
          type="delGroup"
          onClick={removeSelf}
          label={delGroupLabel}
          config={config}
        />
      );

    return (
      <div className={`group--actions ${position}`}>
        <BtnGrp config={config}>
          {setLockSwitch}
          {addRuleBtn}
          {addGroupBtn}
          {delGroupBtn}
        </BtnGrp>
      </div>
    );
  }
}
